import styled from 'styled-components';
// @ts-ignore
import rtl from 'styled-components-rtl';
import { theme, toRem } from '@marriott/mi-ui-library-shop';

export const StyledRFPApprovalRequestDiv = styled.div`
  ${rtl`
  .rfp-btn {
    min-width: 170px;
    @media ${theme.mediaQuery.mobileOnly} {
      min-width: 132px;
    }
  }
  .keysSuccessInput,
  .eventHistoryInput,
  .weddingRequirements
  {
    height: ${toRem(150)};
  }
`}
`;
